<template>
  <div class="view-background-wrapper">
    <div
      v-liquid="bgOptions"
      class="view-background">
  </div>
  </div>
</template>

<script>
import backgrounds from '@/components/ViewBackground/backgrounds'

export default {
  mixins: [backgrounds]
}
</script>

<style lang="scss">
.view-background-wrapper {
  position: fixed;
  overflow: hidden;
  width: 100vw;
  height: 100vh;
}

.view-background {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  transform: scale(1.01);
  transform-origin: center;
}

.view-background canvas {
  position: absolute;
  object-fit: cover;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
</style>
